import axios from 'axios';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import MediDataUploadSearchView from 'components/medidata-upload/MediDataUploadSearchView';
import MediDataUploadTableView from 'components/medidata-upload/MediDataUploadTableView';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouterProps } from 'react-router';
import { Segment } from 'semantic-ui-react';
import { getAllTariffs } from 'services/tariffServices';
import styled from 'styled-components';
import { BillXmlRequestDto, TariffDto } from 'ts-types/api.types';
import { IndexSignature } from 'utils/praxTypes';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledHealthCardPayment = styled(Segment.Group)`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-top: 0 !important;
  background: white;
`;

interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
}

interface State extends IndexSignature {
  billsKey: number,
  billsKeyInt: number,
  bills: Array<BillXmlRequestDto>,
  billsTariffId: number,
  billsLoading: boolean,
  tariffs: Array<TariffDto>,
  errorMessages: Array<string>
}

class MediDataUploadView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      billsKey: 1,
      billsKeyInt: 1,
      bills: [],
      billsTariffId: -1,
      billsLoading: false,

      tariffs: [],
      errorMessages: [],

      cancelTokenSource
    }

    getAllTariffs(cancelTokenSource)
        .then(tariffs => {
          this.setState({
            tariffs
          })
        });
  }

  onFilterBills = (tariffId: number, bills: Array<BillXmlRequestDto>) => {
    this.setState({
      billsKey: (this.state.billsKey + 1),
      bills: bills,
      billsTariffId: tariffId
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  onBillsUpdated = (updatedBills: Array<BillXmlRequestDto>) => {

    const udatedBillsMap: { [key: number]: BillXmlRequestDto } = {};
    updatedBills.forEach(bill => {
      udatedBillsMap[bill.id] = bill;
    });

    const nextBills = this.state.bills.map(bill => (udatedBillsMap[bill.id] || bill));

    this.setState({
      billsKeyInt: (this.state.billsKeyInt + 1),
      bills: nextBills
    })
  };

  onSetErrorMessages = (errorMessages: Array<string>) => {
    this.setState({
      errorMessages
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  render(): React.ReactNode {

    const {currentPatient, getMessage} = this.props;

    const {
      billsKey,
      billsKeyInt,
      bills,
      billsTariffId,
      billsLoading,
      tariffs,
      errorMessages
    } = this.state;


    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.mediDataUpload")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledHealthCardPayment>
            {tariffs && tariffs.length > 0 &&
                <MediDataUploadSearchView
                    onFilterBills={this.onFilterBills}
                    onBillsLoadingChange={this.onBillsLoadingChange}
                    billsLoading={billsLoading}
                    currentPatient={currentPatient}
                    tariffs={tariffs}
                    onSetErrorMessages={this.onSetErrorMessages}
                    errorMessages={errorMessages}
                />
            }
            <MediDataUploadTableView
                key={billsKey}
                billsKeyInt={billsKeyInt}
                bills={bills}
                billsTariffId={billsTariffId}
                billsLoading={billsLoading}
                onBillsUpdated={this.onBillsUpdated}
            />
          </StyledHealthCardPayment>
        </ContentDiv>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(MediDataUploadView)));
